module.exports = __webpack_public_path__ + "static/media/QL-Time-Two-Tone.ce501729.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/QL-Time-Two-Tone.svg
// module id = 245
// module chunks = 0